<template>
  <section class="sc__friendlyHero">
    <div class="sc__friendlyHero__content">
      <h1
        v-if="showHeading"
        class="sc__friendlyHero__heading"
      >
        {{ heading }}
      </h1>

      <h2
        v-if="showSubheading"
        class="sc__friendlyHero__subheading"
      >
        {{ subheading }}
      </h2>

      <div class="sc__friendlyHero__slot">
        <slot />
      </div>
    </div>
  </section>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
@import './style.scss';
</style>
